<template>
  <div v-if="visible" class="api-dialog-overlay" @click="closeIfOverlay">
    <div class="api-dialog">
      <div class="api-dialog-header">
        <h3><span class="api-icon">🔌</span> 随机表情包API</h3>
        <button class="close-button" @click="handleClose">&times;</button>
      </div>
      
      <div class="api-dialog-body">
        <div class="api-section">
          <h4>API地址</h4>
          <div class="api-url-container">
            <code class="api-url">{{ apiBaseUrl }}stickers/rand</code>
            <button class="copy-button" @click="copyApiUrl" :class="{ 'copied': copied }">
              <span v-if="!copied">复制</span>
              <span v-else>已复制 ✓</span>
            </button>
          </div>
        </div>
        
        <div class="api-section">
          <h4>请求方式</h4>
          <p>GET</p>
        </div>
        
        <div class="api-section">
          <h4>返回值示例</h4>
          <pre class="api-response">{{ formattedResponse }}</pre>
        </div>
      </div>
      
      <div class="api-dialog-footer">
        <button class="close-button-bottom" @click="handleClose">关闭</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApiInfoDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:visible'],
  data() {
    return {
      copied: false,
      apiBaseUrl: process.env.VUE_APP_API_BASE_URL || '未配置',
      sampleResponse: {
        code: 200,
        message: "操作成功",
        data: {
          id: 33,
          title: "标题",
          imageUrl: "图片链接",
          likes: 0,
          dislikes: 0,
          createdAt: "2025-04-21T10:21:24",
          type: 0
        }
      }
    }
  },
  computed: {
    formattedResponse() {
      return JSON.stringify(this.sampleResponse, null, 2);
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false);
    },
    closeIfOverlay(event) {
      if (event.target.classList.contains('api-dialog-overlay')) {
        this.handleClose();
      }
    },
    copyApiUrl() {
      const url = `${this.apiBaseUrl}stickers/rand`;
      
      try {
        // 兼容性处理
        if (navigator.clipboard && window.isSecureContext) {
          // 安全上下文中使用 navigator.clipboard API
          navigator.clipboard.writeText(url)
            .then(() => {
              this.showCopiedState();
            })
            .catch(err => {
              console.error('复制失败:', err);
            });
        } else {
          // 回退方案：使用 document.execCommand
          const textarea = document.createElement('textarea');
          textarea.value = url;
          textarea.style.position = 'absolute';
          textarea.style.left = '-9999px';
          document.body.appendChild(textarea);
          textarea.select();
          
          const success = document.execCommand('copy');
          document.body.removeChild(textarea);
          
          if (success) {
            this.showCopiedState();
          }
        }
      } catch (err) {
        console.error('复制出错:', err);
      }
    },
    showCopiedState() {
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 2000);
    }
  }
}
</script>

<style scoped>
.api-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.api-dialog {
  background-color: #fff;
  border-radius: 8px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
}

.api-dialog-header {
  padding: 16px;
  border-bottom: 1px solid #e8f5e9;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f0f0ff;
}

.api-dialog-header h3 {
  margin: 0;
  color: #6a4caf;
  display: flex;
  align-items: center;
  gap: 8px;
}

.api-icon {
  font-size: 1.2em;
}

.close-button {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #999;
}

.close-button:hover {
  color: #333;
}

.api-dialog-body {
  padding: 20px;
}

.api-section {
  margin-bottom: 20px;
}

.api-section h4 {
  margin-bottom: 10px;
  color: #6a4caf;
  border-bottom: 1px dashed #e0e0ff;
  padding-bottom: 5px;
}

.api-url-container {
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 10px;
}

.api-url {
  flex: 1;
  word-break: break-all;
  font-family: 'Courier New', monospace;
  color: #7e57c2;
}

.copy-button {
  padding: 5px 10px;
  background-color: #7e57c2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 10px;
  transition: background-color 0.3s;
  white-space: nowrap;
}

.copy-button:hover {
  background-color: #6a4caf;
}

.copy-button.copied {
  background-color: #4caf50;
}

.api-response {
  background-color: #f8f8f8;
  padding: 15px;
  border-radius: 4px;
  overflow: auto;
  font-family: 'Courier New', monospace;
  font-size: 14px;
  color: #333;
  max-height: 250px;
  text-align: left;
  white-space: pre-wrap;
  line-height: 1.5;
}

.usage-note {
  background-color: #fff8e1;
  padding: 12px;
  border-radius: 6px;
  border-left: 3px solid #ffc107;
}

.usage-note p {
  margin: 8px 0;
  display: flex;
  align-items: center;
  color: #5d4037;
  font-size: 14px;
}

.note-icon {
  margin-right: 8px;
  font-size: 16px;
}

.api-dialog-footer {
  padding: 16px;
  border-top: 1px solid #e8f5e9;
  display: flex;
  justify-content: flex-end;
}

.close-button-bottom {
  padding: 8px 16px;
  background-color: #f5f5f5;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.close-button-bottom:hover {
  background-color: #e5e5e5;
}

@media (max-width: 600px) {
  .api-url-container {
    flex-direction: column;
    align-items: stretch;
  }
  
  .copy-button {
    margin-left: 0;
    margin-top: 10px;
    align-self: flex-end;
  }
}
</style>
